import {IProductService} from './product.service.interface';
import {IProjectService} from './project.service.interface';
import {Injectable} from '@angular/core';
import {MyDeviceRequestContainerModel} from '../models/my-device-request-container.model';
import {MyDialogDataModel} from '../models/my-dialog-data.model';
import {MyNotDeviceRequestContainerModel} from '../models/my-not-device-request-container.model';
import {ProductCategoryTypeEnum} from '../enums/product-category-type.enum';
import {ProductModel} from '../models/product.model';
import {ProjectModel} from '../models/project.model';
import {RequestedDeviceItemModel} from '../models/requested-device-item.model';
import {RequestedNotDeviceItemModel} from '../models/requested-not-device-item.model';
import {StripModalComponent} from '../components/strip-modal/strip-modal.component';
import {Subject} from 'rxjs';
import {MyProductAmountModel} from '../models/my-product-amount.model';
import {MyEditModalCloseActionTypeEnum} from '../enums/my-edit-modal-close-action.enum';
import {DateTimeUtils} from '../utils/date-time.utils';
import {RequestedProductInfoModel} from '../models/requested-product-info.model';
import {RequestedSupplyInfoModel} from '../models/requested-supply-info.model';
import {SupplyAcquisitionTypeEnum} from '../enums/supply-acquisition-type.enum';
import {MyContainerDeviceDedicatedSupplyMetadata} from '../models/my-container-device-dedicated-supply-metadata.model';
import {MyEditDialogStepsEnum} from '../enums/my-edit-dialog-steps.enum';
import {PriceInfoModel} from '../models/price-info.model';
import {ProjectUpdateNotificationFieldEnum} from '../enums/project-update-notification-field.enum';
import {OfferTextModulesContainersUtilsService} from './offer-text-modules-containers-utils.service';
import {ProductsResponseModel} from '../models/products-response.model';
import {MyProductRPricesSelectBaseEnum} from '../enums/my-product-rprices-select-base.enum';
import {CustomPriceInfoModel} from '../models/custom-price-info.model';
import {MyContainersTableIdEnum} from '../enums/my-containers-table-id.enum';
import {EnumUtils} from '../utils/enum.utils';
import {ProjectIsLockedModalComponent} from '../components/project-is-locked-modal/project-is-locked-modal.component';
import {RPriceIdentifierEnum} from '../enums/r-price-identifier.enum';
import {QuotesModel} from '../models/quotes.model';
import {QuotesModalComponent} from '../components/quotes-modal/quotes-modal.component';
import {PriceApprovalStatusEnum} from '../enums/price-approval-status.enum';
import {ObjectsUtils} from '../utils/objects.utils';
import {ProjectsContactsWidgetService} from './projects-contacts-widget.service';
import {ContainerUtilsService} from './container-utils.service';
import {ContainerListsUtilsService} from './container-lists-utils.service';
import {AcquisitionTypeEnum} from '../enums/acquisition-type.enum';
import {ProjectStatusEnum} from '../enums/project-status.enum';
import {ProjectDistributorStatusEnum} from '../enums/project-distributor-status.enum';
import {ProjectsConst} from '../consts/projects-consts';
import {ModalDynamicV3Service} from '../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Injectable()
export class EditModalService {
// tslint:disable:max-line-length

    private dialogModel: MyDialogDataModel;


    public isDialogOpened = false;
    public currentStepId: MyEditDialogStepsEnum;

    public error: { errorCode: number, errorMessage: string };


    private activeSpinnerIdSource = new Subject<string>();
    public activeSpinnerIdChangeAnnounced$ = this.activeSpinnerIdSource.asObservable();


    public announceActiveSpinnerIdChange(spinnerId: string) {
        // console.log('announceActiveSpinnerIdChange', spinnerId);
        this.activeSpinnerIdSource.next(spinnerId);
    }

    // tslint:disable:member-ordering
    private tableContentChangedSource = new Subject<MyContainersTableIdEnum>();
    public tableContentChangedAnnounced$ = this.tableContentChangedSource.asObservable();

    public announceTableContentChanged(tableId: MyContainersTableIdEnum) {
        this.updateActiveProjectContainerExistenceValidationHelperStatus();
        this.tableContentChangedSource.next(tableId);
    }

    private quoteClosingDateChangedSource = new Subject<void>();
    public quoteClosingDateChangedAnnounced$ = this.quoteClosingDateChangedSource.asObservable();

    public announceQuoteClosingDateChanged() {
        this.quoteClosingDateChangedSource.next();
    }


    constructor(
        private projectService: IProjectService,
        private productService: IProductService,
        private modalDynamicV3Service: ModalDynamicV3Service,
        private offerTextModulesContainersUtilsService: OfferTextModulesContainersUtilsService,
        private projectsContactsWidgetService: ProjectsContactsWidgetService,
        public containerUtilsService: ContainerUtilsService,
        public containersListsUtilsService: ContainerListsUtilsService
    ) {
    }


    public async init(project: ProjectModel = null) {

        console.log('dialog model initialization starts');

        const isNewProject: boolean = !project;


        if (!this.dialogModel) {
            this.dialogModel = new MyDialogDataModel();
            this.containerUtilsService.initDialogModel(this.dialogModel);
            this.containersListsUtilsService.initDialogModel(this.dialogModel);
        }
        // this.dialogModel = this.dialogModel ? this.dialogModel : {} as MyDialogDataModel;

        // - load product if they are not already initialized
        // - reset or init available containers
        // process all product type (devices, war., sup., acc. )
        try {
            await this.resetAvailableProductContainersArrays(project && project.id, false);
        } catch (e) {
            console.log('error occurred - dialog model', this.dialogModel);
            throw e;
        }
        // at this point all helping arrays and structures are initialized and are empty without user data
        // ( no user input, no user data form rest)


        // init all requestedContainers to empty array if they not exist yet or clear the data from last usage(another project editing)
        // requestedContainers contains info, which products are selected by the user to be displayed/requested in main dialog tables,
        // such selected devices, acces., and wars. on 3.dialog page or general or printsmart supp. on 5.page
        this.clearRequestProductsContainersLists();

        // this.editModalDevelopUtilsService.testAccessoryConnection_developTest('initCPID', this.dialogModel);


        if (isNewProject) {
            // console.log('init new project');
            this.dialogModel.project = ProjectModel.getEmptyProject();
        } else {
            // console.log('editing given project', project);
            this.dialogModel.project = project;

            // fix missing supply distributor in project requestedSupplyInfo if the supplyAcquisitionType is MPS_type
            // it should not be possible to save a project with missing supply distributor,
            // but there was some error and many projects have missing supply distributor
            if (this.dialogModel.project.supplyAcquisitionType !== EnumUtils.getKeyByValue(SupplyAcquisitionTypeEnum, SupplyAcquisitionTypeEnum.PURCHASE) &&
                this.dialogModel.project.requestedSupplyInfo && !this.dialogModel.project.requestedSupplyInfo.supplyDistributorId) {
                this.dialogModel.project.requestedSupplyInfo.supplyDistributorId = this.dialogModel.supplyDistributors?.find(d => d.name === ProjectsConst.MPS_BROTHER_SUPPLY_DISTRIBUTOR_NAME).id;
            }


            if (project.tenderDocuments && project.tenderDocuments[0] && project.tenderDocuments[0].id !== undefined) {
                console.warn('tenderDocumens have ids, remove mocked id');
                console.log('project.tenderDocuments ', project.tenderDocuments);
                // project offerTextModule ids will not be proived, so the ids there must be generated for validation
                console.log('project.offerTextModules', project.offerTextModules);

            } else {
                if (project.tenderDocuments) {
                    for (let i = 0, len = project.tenderDocuments.length; i < len; i++) {
                        project.tenderDocuments[i].id = project.tenderDocuments[i].id ? project.tenderDocuments[i].id : i;
                    }
                }
            }


            if (project.offerTextModules) {
                for (let i = 0, len = project.offerTextModules.length; i < len; i++) {
                    project.offerTextModules[i].id = i;
                }
            }
            this.dialogModel.projectRepository = this.getCopyProject(project);
            // remove next section part - ends

            if (project.priceApprovalStatus === PriceApprovalStatusEnum[PriceApprovalStatusEnum.PRICES_APPROVED]) {
                this.updateRPricesBasedApprovalStatusDetailsHelper();

                if (project.offerTextModules) {
                    for (let i = 0, len = project.offerTextModules.length; i < len; i++) {
                        project.offerTextModules[i].id = i;
                    }
                }

                if (this.dialogModel.onRPricesBasedApprovalStatusDetailsHelper === PriceApprovalStatusEnum.PRICE_APPROVAL_REQUESTED) {
                    // save project to project repository
                    this.dialogModel.projectRepository = this.getCopyProject(project);
                }
            }

            // copy/synchronize amounts and request data from just loaded project to available and requested containers
            this.reinitAllProductContainersByProject(this.dialogModel.project);
            this.reinitProductsRequiredFlags(this.dialogModel);
            this.offerTextModulesContainersUtilsService.reinitOfferTextModulesContainers(this.dialogModel);


        }


        // the fist dialog page and project name on second page must be specified to allow continue to the reset of the dialog pages
        // but the warnings are not displayed immediately after dialog is opened
        this.dialogModel.isProjectNameSaveValidationVisibilityForced = false;
        this.dialogModel.isFirstStepSaveValidationVisibilityForced = false;
        this.dialogModel.isStep3ButtonsValidationVisibilityForced = false;
        this.dialogModel.isStep4ButtonsValidationVisibilityForced = false;

        if (!isNewProject) {
            // project can be loaded from rest without products or supply infos, so init them in this case
            // we need them to collect rollout dates and so on
            this.checkProjectInfosExistence();
            this.checkDistributorsExistence();


            // the dialog distinguishes between null and undefined values for secondary
            // distributors to display right wording on different places in select inputs if the distributor is not selected
            if (this.dialogModel.project.requestedProductInfo.secondaryProductDistributorId === null) {
                this.dialogModel.project.requestedProductInfo.secondaryProductDistributorId = undefined;
            }
            if (this.dialogModel.project.requestedSupplyInfo.secondarySupplyDistributorId === null) {
                this.dialogModel.project.requestedSupplyInfo.secondarySupplyDistributorId = undefined;
            }
        }
    }


    // ======= init methods   =======
    // creates new container arrays or clears old project user data if containers are already initialized
    // and make them ready for working with another "new" project
    private async resetAvailableProductContainersArrays(projectId: number, forceReload = false): Promise<void> {
        // PPU_log console.log('resetAvailableProductContainersArrays');

        // this.editModalDevelopUtilsService.testAccessoryConnection_developTest('resetAvailableProductContainersArrays', this.dialogModel);

        if (!forceReload && this.dialogModel.availableDevicesContainers) {
            // all containers in available arrays are already initialized but for another project
            // and projectId is not provided, so product not depends on projectId so the product for last project can be used
            this.clearAllAvailableProductContainersUserData();
            // this.editModalDevelopUtilsService.allAvailableProductContainersAmountAreCleared_DevelopTest(this.dialogModel);
            // this.editModalDevelopUtilsService.testAccessoryConnection_developTest('initAvailableProductContainersArrays1', this.dialogModel);

        } else {
            if (forceReload || !this.dialogModel.products) {
                // load products from rest
                const productsResponse: ProductsResponseModel = await this.productService.getProjectProducts(projectId);
                this.dialogModel.products = productsResponse.brotherProducts;
                this.dialogModel.supplyDistributors = productsResponse.supplyDistributors &&
                    productsResponse.supplyDistributors.sort((a, b) => (a.name < b.name) ? -1 : ((a.name === b.name) ? 0 : 1));


                this.dialogModel.productDistributors = productsResponse.productDistributors &&
                    productsResponse.productDistributors.sort((a, b) => (a.name < b.name) ? -1 : ((a.name === b.name) ? 0 : 1));
                if (this.dialogModel.supplyDistributors && this.dialogModel.supplyDistributors.length < 1) {
                    console.error('<KO> supplyDistributors comes empty from rest, response:', productsResponse);
                }
                if (this.dialogModel.productDistributors && this.dialogModel.productDistributors.length < 1) {
                    console.error('<KO> productDistributors comes empty from rest, response:', productsResponse);
                }
                // convert to useful structure  // create devices 2d array and other available and index arrays
                if (this.dialogModel.products && this.dialogModel.products.length) {
                    this.containersListsUtilsService.wrapProductsWithContainers(this.dialogModel.products);
                    // this.editModalDevelopUtilsService.testAccessoryConnection_developTest('initAvailableProductContainersArrays2', this.dialogModel);
                } else {
                    this.dialogModel.products = null;
                    // console.log('[1] this.dialogModel:', this.dialogModel);
                    throw new Error('Products list is empty or was not loaded');
                }
            }
        }
        this.dialogModel.filteredProductDistributors = []; // will be reinitialized on 3. page
        this.dialogModel.filteredSupplyDistributors = []; // will be reinitialized on 5. page
    }


    /**
     * it will updated the someItemContainerIsActive, which indicate if project contains any item to order
     * wee need dialog validation , because without any ordered item the request/project cannot be sent to process
     */
    public updateActiveProjectContainerExistenceValidationHelperStatus() {
        this.dialogModel.someItemContainerIsActive = +this.projectContainsAnythingToOrder();
        this.dialogModel.someDeviceTableContainerIsActive = +(this.dialogModel.isDeviceOrderRequested && this.dialogModel.containsSomeRequestedDevicesContainers());
        this.dialogModel.someAccessoryTableContainerIsActive = +(this.dialogModel.isAccessoryOrderRequested &&
            this.dialogModel.requestedAccessoryContainers && this.dialogModel.requestedAccessoryContainers.length);

        this.dialogModel.someWarrantyTableContainerIsActive = +(this.dialogModel.isWarrantyOrderRequested &&
            this.dialogModel.requestedWarrantyContainers && this.dialogModel.requestedWarrantyContainers.length);

        // this.dialogModel.someServicesTableContainerIsActive = +(this.dialogModel.isServiceOrderRequested &&
        //     this.dialogModel.requestedPreselectedGeneralDevicesWith_Service_Containers &&
        //     this.dialogModel.requestedPreselectedGeneralDevicesWith_Service_Containers.some(deviceContainer => !!(deviceContainer.services && deviceContainer.services.length)));

        this.dialogModel.someUpgradesTableContainerIsActive = +(this.dialogModel.isUpgradesOrderRequested &&
            this.dialogModel.requestedUpgradesContainers && this.dialogModel.requestedUpgradesContainers.length);
    }


    /**
     * return true if project contains anything to order
     */
    public projectContainsAnythingToOrder(): boolean {
        return this.dialogModel && this.dialogModel.containsSomeRequestedItemContainers();
    }

    // clear/initialize all requested arrays to empty array (remove old project user product request by clearing requested containers arrays)
    private clearRequestProductsContainersLists() {
        this.dialogModel.requestedDevicesContainers = [];
        this.dialogModel.isDeviceOrderRequested = true;

        this.dialogModel.requestedAccessoryContainers = [];
        this.dialogModel.isAccessoryOrderRequested = true;

        this.dialogModel.requestedWarrantyContainers = [];
        this.dialogModel.isWarrantyOrderRequested = true;

        this.dialogModel.requestedUpgradesContainers = [];
        this.dialogModel.isUpgradesOrderRequested = true;


        this.dialogModel.isServiceOrderRequested = true;
        this.dialogModel.isServiceDescriptionActive = false;

        this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers = [];
        this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers = [];
        this.dialogModel.requestedGeneralNoCategorisedSupplyContainers = [];

        // this.editModalDevelopUtilsService.allRequestedProductContainersAmountAreCleared_DevelopTest(this.dialogModel);

        this.announceTableContentChanged(MyContainersTableIdEnum.allTablesContainers);

    }


    // init data in all containers by user data from give project (loaded from rest)
    private reinitAllProductContainersByProject(project: ProjectModel) {
        // ===== we have to load data form rest to containers

        // PPU_log console.log('reinitAllProductContainersByProject starts');

        // console.log('reinitAllProductContainersByProject for project:', project);
        // console.log('requestedProductInfo', project.requestedProductInfo);
        // console.log('dialog model', this.dialogModel);

        // ===== start device processing....
        // ===== process requestedProductInfo... all devices, accessories and warranties
        // forEach goes trough all requestedProduct in project loaded form rest and copy data into available containers
        if (project.requestedProductInfo && project.requestedProductInfo.requestedProducts) {
            project.requestedProductInfo.requestedProducts.forEach(productRequest => {
                // find product by its sku
                const product = this.getProductBySku(productRequest.sku); // finds product in products array loaded form rest
                if (!product) {
                    // unexpected state
                    console.warn('product with sku ' + productRequest.sku + ' was not found', productRequest);
                    console.log('complete array:', project.requestedProductInfo.requestedProducts);
                } else {  // product found
                    if (ProductModel.isDevice(product)) {
                        // find productContainer in availableDevicesContainers by product.sku
                        const deviceContainer = <MyDeviceRequestContainerModel>
                            this.containersListsUtilsService.getContainerBySku(this.dialogModel.availableDevicesContainers, product.sku);

                        // deviceRequest for device contains amount, priceNote, price , pages metaData
                        deviceContainer.deviceRequest = productRequest as RequestedDeviceItemModel;
                        deviceContainer.deviceRequest.priceInfo = Object.assign(
                            PriceInfoModel.getNewInstance(ProductModel.getItemDedicatedRPrices(deviceContainer.itemToOrder)),
                            deviceContainer.deviceRequest.priceInfo);
                        if (!deviceContainer.deviceRequest.priceInfo.customPriceInfo) {
                            deviceContainer.deviceRequest.priceInfo.customPriceInfo = new CustomPriceInfoModel();
                        }
                        deviceContainer.containerSharedMetadata.addToProductOrderList = true;
                        deviceContainer.deviceAmount = new MyProductAmountModel(productRequest.amount);
                        // console.log('deviceContainer found for product:', deviceContainer);
                    } else {


                        // handle warranties and accessories without parent device
                        let arrayToSearchIn: MyNotDeviceRequestContainerModel[];
                        switch (ProductCategoryTypeEnum[product.category]) {
                            case ProductCategoryTypeEnum.WARRANTY:
                                arrayToSearchIn = this.dialogModel.availableWarrantyContainers;
                                break;
                            case ProductCategoryTypeEnum.ACCESSORY:
                                arrayToSearchIn = this.dialogModel.availableAccessoryContainers;
                                break;
                            case ProductCategoryTypeEnum.SERVICE:
                                console.error('service found in requested products... unexpected state, ' +
                                    'service should not exists in dealerApp');
                                break;
                            case ProductCategoryTypeEnum.UPGRADE:
                                arrayToSearchIn = this.dialogModel.availableUpgradesContainers;
                                break;
                            case ProductCategoryTypeEnum.SUPPLY:
                                console.error('supply found in requested products... unexpected state, ' +
                                    'supply data should be stored in requestedSupplyInfo');
                                break;
                            default:
                                arrayToSearchIn = null;
                        }

                        const notDeviceContainer = <MyNotDeviceRequestContainerModel>
                            this.containersListsUtilsService.getContainerBySku(arrayToSearchIn, productRequest.sku);
                        if (notDeviceContainer) {  // accessory or warranty found in this dedicated array
                            // ... the for item container was found, so the data must be copied in
                            // warranty and accessor are handled on dialog 4.page and addToProductOrderList is what is used for

                            notDeviceContainer.notDeviceRequest = productRequest as RequestedNotDeviceItemModel;  // this is not the supply, so direct setting of  notDeviceRequest is allowed

                            notDeviceContainer.notDeviceRequest.priceInfo = Object.assign(
                                PriceInfoModel.getNewInstance(notDeviceContainer.itemToOrder.rPrices),
                                notDeviceContainer.notDeviceRequest.priceInfo);
                            if (!notDeviceContainer.notDeviceRequest.priceInfo.customPriceInfo) {
                                notDeviceContainer.notDeviceRequest.priceInfo.customPriceInfo = new CustomPriceInfoModel();
                            }

                            notDeviceContainer.containerSharedMetadata.addToProductOrderList = true;
                            notDeviceContainer.waAcLsAmount = new MyProductAmountModel(productRequest.amount);
                        } else {
                            // these method only copies amounts and so on into "availableContainers Array"
                            // so if we are not able to find dedicated container... something is wrong
                            console.error(product.category + 'notDeviceContainer not found, unexpected state', notDeviceContainer);
                        }
                        // console.log('notDevice (warranty, or accessory) product found', notDeviceContainer);
                    }
                }
            });
        }


        // =====  device processing finished
        // data from loaded project was copied in dedicated available containers, but requested contaniers are still not initialized at this point


        // ===== process requestedSupplies... all supplies

        // load data to 3. page containers arrays , it will refresh requested devices... it contains all device and printSmart devices
        this.refreshRequestedNotSupplyNotServicesNotCustomContainers(MyContainersTableIdEnum.allTablesContainers); // some supplies is ordered directly for requested device, so the devices containers must be actualized
        // lodaing data to 3. page container finished


        // at this point the supply data is not processed.. they are empty
        // so all supplies containers array which depends on user input are empty,which means all suppply containers array
        // only availableSupplyContainer list is filled with data, because it is not about project but about supplies itself


        // so now we have to init availableSelectedPrintSmartDevice, but at this point it is still not about
        // user supply request, it will filter devices -> ordered devices which has some supplies to be ordered for
        // the available print smart list is directly displayed on 5. dialog page , so the models must be fully
        // initialized to be able work with 5. page printSmart table

        // add devices with supplies which was selected on 3.page to 5.page dialog table (availablePreselectedPrintSmartDevicesWithSupplyContainers)
        // to arrays which serve to allow user select them, so these devices are still without user printSmart supply data:
        this.refreshAvailablePreselectedPrintSmartDeviceWithSupplyContainers();
        // cthe general devices will be displayed only on subdialog, so the full model initialization is not necessary at this point');
        this.refreshAvailablePreselectedGeneralDeviceWithSupplyContainers();

        // this.editModalDevelopUtilsService.testSupplyConnection_notDeviceRequest_developTest('reinitAllProducts2', this.dialogModel);


        // now init requestedSupplyContainers by project.requestedSupplyInfo.requestedSupplies:
        if (project.requestedSupplyInfo && project.requestedSupplyInfo.requestedSupplies) {
            project.requestedSupplyInfo.requestedSupplies.forEach(requestedSupply => {

                if (this.isPrintSmartSupplyAcquisitionType()) {  // printSmart


                    if (this.isPrintSmart_SupplyPagePriceAcquisitionTyp()) {  // printSmart price per page mode
                        // it this case all incoming supplies are not supplies....
                        // this is special supply for devicePricePerPage, which is in fact not the supply
                        // in this case the sku contains parent sku instead the parentSkuMapping (parentSkuMapping should be null)
                        // usually the sku contains product sku and not the parent sku
                        const printSmartDeviceContainer =
                            this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.find(deviceContainer =>
                                deviceContainer.itemToOrder.sku === requestedSupply.sku);


                        // if (requestedSupply.parentSkuMapping && requestedSupply.parentSkuMapping.length > 0) {
                        //     console.warn('the requestedSupply (which is in fact supply request) contains parentSkuMapping which is strange for this case', requestedSupply);
                        // }

                        // if (printSmartDeviceContainer.devicePricePerPage) {
                        //     // if devicePricePerPage in initialized to work with,  but without user data then it is oK, otherwise throw err
                        //     if (printSmartDeviceContainer.devicePricePerPage.developStatus !== 'emptyNew') {
                        //         console.error('the printSmartDeviceContainer has already defined devicePricePerPage, status: ' + printSmartDeviceContainer.devicePricePerPage.developStatus, printSmartDeviceContainer);
                        //     }
                        //     this.editModalDevelopUtilsService.testDevicePagePricesDiffer_developTest(printSmartDeviceContainer.devicePricePerPage, 'top');
                        // }


                        // it this mode (SupplyPagePriceAcquisitionTyp) the table do not contains any supplies only the device, so we are working wit devices only
                        // by new spec the addToRequestedPrintSmartDeviceSupplyOrderList is in fact useless because for app printsmart devices their supplies will be ordered and the merchant user
                        // have no choice... all mps devices must be reordered with its dedicated supplies, but for back-compatibility the addToRequestedPrintSmartDeviceSupplyOrderList must be set to true,
                        // alter it could be removed , so remove addToRequestedPrintSmartDeviceSupplyOrderList logic
                        // printSmartDeviceContainer.containerSharedMetadata.addToRequestedPrintSmartDeviceSupplyOrderList = true;


                    } else { // printSmart price supply items order  (MPS_BASED_ON_UNIT_COUNT)

                        let lastProcessedSku;
                        let printSmartDeviceContainer;

                        requestedSupply.parentSkuMapping.forEach(parentSkuMapping => {
                            if (parentSkuMapping.sku !== lastProcessedSku) {
                                printSmartDeviceContainer =
                                    this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.find(deviceContainer =>
                                        deviceContainer.itemToOrder.sku === parentSkuMapping.sku);
                                if (printSmartDeviceContainer) {

                                    // printSmartDeviceContainer.containerSharedMetadata.addToRequestedPrintSmartDeviceSupplyOrderList = true;
                                    lastProcessedSku = parentSkuMapping.sku;


                                } else {
                                    console.error('deviceContainer not found in availablePreselectedPrintSmartDevicesWithSupplyContainers for sku:',
                                        parentSkuMapping.sku);
                                }
                            }

                            // console.log('reinitAllProductContainersByProject - parentSkuMapping source', parentSkuMapping);
                            // console.log('reinitAllProductContainersByProject - PrintSmartDeviceContainer initialized', printSmartDeviceContainer);


                            // printSmartDeviceContainer is marked to be displayed is MPS supply table,
                            // the device will be displayed with all its supply not matter if is contained in in order or not
                            // so now we have to find dedicated supply container in its supplies and and init its notDeviceOrder and its priceInfo
                            const supplyContainer = printSmartDeviceContainer.supplies.find(supply => supply.itemToOrder.sku === requestedSupply.sku);
                            if (supplyContainer) {
                                if (requestedSupply.priceInfo && requestedSupply.priceInfo.customPriceInfo === null) {
                                    delete requestedSupply.priceInfo.customPriceInfo;
                                }
                                supplyContainer.notDeviceRequest.priceInfo = Object.assign(PriceInfoModel.getNewInstance(supplyContainer.itemToOrder.rPrices), requestedSupply.priceInfo);
                                supplyContainer.parentPrintSmartDedicatedSupplyAmount = new MyProductAmountModel(parentSkuMapping.amount);
                            } else {
                                console.error('supplyContainer was not found in printSmartDeviceContainer predefined supplies', printSmartDeviceContainer);
                            }


                        });
                    }


                } else {  // general supplies (kaufen)

                    // at this point, the availablePreselectedGeneralDevicesWithSupplyContainers contains all devices which are selected in step 3
                    // so if the parentSkuMapping is presented, go through it and for each parentSkuMapping find device
                    // and supply in it a and copy amount the parentDedicatedGeneralSupplyAmount, requestedArray will be updated later
                    // atention: there can be 3 situation
                    // - supply contains skuMapping, so the values go to categorised array
                    // - supply do not contais skuMapping, so the values go to notCategorised arry
                    // - but thre is one more situation, where the supply can be contained in both and this is not maintained by rest spec yet
                    if (requestedSupply?.parentSkuMapping?.length > 0) {
                        // parentSkuMapping exists
                        requestedSupply.parentSkuMapping.forEach(parentSkuMapping => {
                            const deviceContainer =
                                this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers.find(
                                    dContainer => dContainer.itemToOrder.sku === parentSkuMapping.sku
                                );
                            if (deviceContainer) {
                                // deviceContainer.containerSharedMetadata.addToNoCategorised5stepGeneralSupplyOrderList = true;
                                const supplyContainer = deviceContainer.supplies.find(
                                    sContainer => sContainer.itemToOrder.sku === requestedSupply.sku);
                                if (supplyContainer) {
                                    supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata =
                                        new MyContainerDeviceDedicatedSupplyMetadata(parentSkuMapping.amount);
                                    supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.addTo5stepOrderList = true;
                                    // supplyContainer.notDeviceRequest.priceInfo = Object.assign( supplyContainer.notDeviceRequest.priceInfo,requestedSupply.priceInfo);
                                    if (requestedSupply.priceInfo && requestedSupply.priceInfo.customPriceInfo === null) {
                                        delete requestedSupply.priceInfo.customPriceInfo;
                                    }
                                    supplyContainer.notDeviceRequest.priceInfo = Object.assign(PriceInfoModel.getNewInstance(supplyContainer.itemToOrder.rPrices), requestedSupply.priceInfo);
                                } else {
                                    console.error('supplyContainer not found in deviceContainer.supplies',
                                        supplyContainer);
                                }

                            } else {
                                console.error('deviceContainer not found in availablePreselectedGeneralDevicesWithSupplyContainers',
                                    deviceContainer);
                            }
                        });
                    } else {

                        // parentSkuMapping do not exists
                        const supplyContainer = this.dialogModel.availableSuppliesContainers.find(
                            sContainer => sContainer.itemToOrder.sku === requestedSupply.sku
                        );
                        if (supplyContainer) {
                            supplyContainer.containerSharedMetadata.addToNoCategorised5stepGeneralSupplyOrderList = true;
                            supplyContainer.noParentGeneralSupplyAmount = new MyProductAmountModel(requestedSupply.amount);

                            supplyContainer.notDeviceRequest = RequestedNotDeviceItemModel.getNewInstance(PriceInfoModel.getNewInstance(supplyContainer.itemToOrder.rPrices));
                            delete supplyContainer.notDeviceRequest.parentSkuMapping;  // this is about noParrentSupplyContainer, so parentSkuMapping is useless

                            if (requestedSupply.priceInfo && requestedSupply.priceInfo.customPriceInfo === null) {
                                delete requestedSupply.priceInfo.customPriceInfo;
                            }
                            supplyContainer.notDeviceRequest.priceInfo = Object.assign(supplyContainer.notDeviceRequest.priceInfo, requestedSupply.priceInfo);

                        } else {
                            console.error('deviceContainer not found in availableSuppliesContainers',
                                supplyContainer);
                        }
                    }


                }
            });
        }

        if (this.isPrintSmartSupplyAcquisitionType()) {
            this.refreshRequestedPrintSmartSupplyContainers();
        } else {
            this.refreshAllRequestedGeneralSupplyContainers();
        }
        // console.log('done requestedPreselectedPrintSmartDevicesWithSupplyContainers', this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers);

        // for dealer app the service containers are replaced with requestedServiceComment
        this.dialogModel.isServiceOrderRequested = !!(project.requestedProductInfo && project.requestedProductInfo.requestedServiceComment);
        this.dialogModel.isServiceDescriptionActive = this.dialogModel.isServiceOrderRequested;

    }


    private checkProjectInfosExistence() {
        if (this.dialogModel && this.dialogModel.project) {
            const project = this.dialogModel.project;
            project.requestedSupplyInfo = project.requestedSupplyInfo ? project.requestedSupplyInfo : new RequestedSupplyInfoModel();
            project.requestedProductInfo = project.requestedProductInfo ? project.requestedProductInfo : new RequestedProductInfoModel();
        }

    }

    private checkDistributorsExistence() {
        // console.log('checkDistributorsExistence');
        if (this.dialogModel && this.dialogModel.project &&
            this.dialogModel.project.requestedProductInfo &&
            (this.dialogModel.project.requestedProductInfo.productDistributorId ||
                this.dialogModel.project.requestedProductInfo.productDistributorId === 0)) {
            const productDistributor = this.dialogModel.productDistributors.find(
                pd => pd.id === this.dialogModel.project.requestedProductInfo.productDistributorId
            );

            if (!productDistributor) {
                console.warn('given product distributor id does not exist, projectDistributorID ( ' +
                    this.dialogModel.project.requestedProductInfo.productDistributorId + ' ) was removed');
                this.dialogModel.project.requestedProductInfo.productDistributorId = undefined;
            }
        }

        if (this.dialogModel && this.dialogModel.project &&
            this.dialogModel.project.requestedSupplyInfo &&
            (this.dialogModel.project.requestedSupplyInfo.supplyDistributorId ||
                this.dialogModel.project.requestedSupplyInfo.supplyDistributorId === 0)) {
            const supplyDistributor = this.dialogModel.supplyDistributors.find(
                pd => pd.id === this.dialogModel.project.requestedSupplyInfo.supplyDistributorId
            );

            if (!supplyDistributor) {
                console.warn('give supply distributor id does not exist, supplyDistributor ( ' +
                    this.dialogModel.project.requestedSupplyInfo.supplyDistributorId + ' ) was removed');
                this.dialogModel.project.requestedSupplyInfo.supplyDistributorId = undefined;
            }
        }
    }

    private clearAllAvailableProductContainersUserData() {

        this.containersListsUtilsService.clearDeviceContainersListUserData(this.dialogModel.availableDevicesContainers);
        this.containersListsUtilsService.clearNotDeviceContainersUserData(this.dialogModel.availableAccessoryContainers);
        this.containersListsUtilsService.clearNotDeviceContainersUserData(this.dialogModel.availableWarrantyContainers);

        this.containersListsUtilsService.clearNotDeviceContainersUserData(this.dialogModel.availableSuppliesContainers);

        this.containersListsUtilsService.clearNotDeviceContainersUserData(this.dialogModel.availableUpgradesContainers);

        // next both array content depends on the previous dialog steps user input, so the content should be cleared completely
        // and restored later after user data will be available and before will be used on 5.page dialog
        this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers = [];
        this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers = [];

        // this.dialogModel.availableGeneralNoCategorisedSupplyContainers is not used by new spec and logic,
        // -> at this point is the same as this.dialogModel.availableSuppliesContainers
    }

    // =======  init methods end  =======


    // =======  methods used in components directly  =======
    /**
     * initialize requestedDevicesContainers, requestedWarrantyContainers, requestedAccessoryContainers
     * initializing means that it go trough all available containers and pick those which are selected by user ( added to order)
     *
     * and also to method is called after eny add items on both 3.step and 4.step are closed and updates requestedContainers
     */
    public refreshRequestedNotSupplyNotServicesNotCustomContainers(tableId: MyContainersTableIdEnum): void {
        //  console.log('refreshRequestedNotSupplyNotServicesNotCustomContainers:', MyContainersTableIdEnum[tableId], tableId);

        if (tableId === MyContainersTableIdEnum.allTablesContainers) {
            Object.keys(MyContainersTableIdEnum).forEach(key => {

                if (Number.isFinite(+key)) { // filter out string values
                    const currentTableId = +key;
                    switch (currentTableId) {
                        case  MyContainersTableIdEnum.allTablesContainers:
                        case  MyContainersTableIdEnum.step5TableContainers:
                        case  MyContainersTableIdEnum.step4ServicesContainers:
                            // do nothing
                            break;
                        default:
                            this.refreshRequestedNotSupplyNotServiceSingleContainer(+key);
                    }
                }
            });
        } else {
            this.refreshRequestedNotSupplyNotServiceSingleContainer(tableId);
        }

        this.announceTableContentChanged(tableId);
    }


    private refreshRequestedNotSupplyNotServiceSingleContainer(tableId: MyContainersTableIdEnum): void {

        // console.log('refreshRequestedNotSupplySingleContainer', MyContainersTableIdEnum[tableId], tableId);


        switch (tableId) {
            case MyContainersTableIdEnum.step3DeviceTableContainers:
                if (this.dialogModel.availableDevicesContainers) {
                    this.dialogModel.requestedDevicesContainers = this.containersListsUtilsService.filterAndCopyRequestedContainersOnly(this.dialogModel.availableDevicesContainers);
                } else {
                    console.error('availableDevicesContainers missing');
                }
                break;
            case MyContainersTableIdEnum.step4AccessoriesTableContainers:
                if (this.dialogModel.availableAccessoryContainers) {
                    // - availableWarrantyContainers contains all accessories with and without device parents
                    //   only the presentation variable addToProductOrderList
                    // - is modified via pointers into availableDeviceContainers and noParentAccessoryContainersIndex
                    this.dialogModel.requestedAccessoryContainers =
                        this.containersListsUtilsService.filterAndCopyRequestedContainersOnly(this.dialogModel.availableAccessoryContainers);
                } else {
                    console.error('availableAccessoryContainers missing');
                }
                break;
            case MyContainersTableIdEnum.step4WarrantiesTableContainers:
                if (this.dialogModel.availableWarrantyContainers) {
                    // - availableWarrantyContainers contains all warranties with and without device parents
                    //   only the presentation variable addToProductOrderList
                    // - is modified via pointers into availableDeviceContainers and noParentWarrantyContainersIndex
                    this.dialogModel.requestedWarrantyContainers = this.containersListsUtilsService.filterAndCopyRequestedContainersOnly(this.dialogModel.availableWarrantyContainers);
                } else {
                    console.error('availableWarrantyContainers missing');
                }
                break;
            case MyContainersTableIdEnum.step4ServicesContainers:
                break;
            case MyContainersTableIdEnum.step4UpgradesContainers:
                if (this.dialogModel.availableUpgradesContainers) {
                    // - availableUpgradesContainers contains all warranties with and without device parents
                    //   only the presentation variable addToProductOrderList
                    // - is modified via pointers into availableDeviceContainers
                    this.dialogModel.requestedUpgradesContainers = this.containersListsUtilsService.filterAndCopyRequestedContainersOnly(this.dialogModel.availableUpgradesContainers);
                } else {
                    console.error('availableUpgradesContainers missing');
                }
                break;

            case MyContainersTableIdEnum.step5TableContainers:
            default:
                console.error('refreshRequestedNotSupplySingleContainer - unexpected tableId', tableId, MyContainersTableIdEnum[tableId]);
        }

    }


    // ========== main methods called before dialog is submitted/closed
    // called after main dialog is submitted only, so the data should be saved

    // converts working data(data in all containers) to the project object to make it ready to send to rest
    // called before the edit dialog is closed, so then the data can be saved directly
    public collectProjectRequestedInfosForRest(): void {

        // PPU_log console.log('collectProjectRequestedInfosForRest start, requestedProduct and requestedSupplies data to restModels, dialogModel:', this.dialogModel);

        //  ===== requestedProductInfo
        // currently the requestedProductInfo contains data loaded form rest, so we have clear it and updated it with new input from user
        this.dialogModel.project.requestedProductInfo =
            this.dialogModel.project.requestedProductInfo ? this.dialogModel.project.requestedProductInfo : new RequestedProductInfoModel();

        this.dialogModel.project.requestedProductInfo.requestedProducts = [];
        // create shortcut variable
        const projectsRequestedProductsSC = this.dialogModel.project.requestedProductInfo.requestedProducts;

        // PPU_log console.log(' - processing requested devices');

        //  ========= process requested devices (no children like accessory )=============

        this.dialogModel.project.hardwareAcquisitionType = AcquisitionTypeEnum[this.dialogModel.isDeviceOrderRequested && this.dialogModel.containsSomeStep3Containers() ? AcquisitionTypeEnum.PURCHASE : AcquisitionTypeEnum.NONE];
        if (this.dialogModel.isDeviceOrderRequested) {
            this.dialogModel.requestedDevicesContainers.forEach(deviceContainer => {
                // try to find current processed product in output array just for sure... it shouldn't be found if everything is as should be
                const projectRequestedProduct = <RequestedDeviceItemModel>projectsRequestedProductsSC
                    .find(rp => rp.sku === deviceContainer.itemToOrder.sku);
                if (projectRequestedProduct) {
                    // every device should be contained only one time, so if will be found more then one time, then is something wrong
                    console.error('device was found in requestedProduct, probably is something wrong', deviceContainer.deviceRequest);
                    projectRequestedProduct.amount += deviceContainer.deviceAmount.amount;
                } else {
                    // add metadata from device request (mono and color page amount)
                    const deviceRequestToAdd = Object.assign(new RequestedDeviceItemModel(), deviceContainer.deviceRequest);
                    deviceRequestToAdd.sku = deviceRequestToAdd.sku ? deviceRequestToAdd.sku : deviceContainer.itemToOrder.sku;
                    deviceRequestToAdd.amount = deviceContainer.deviceAmount.amount;
                    deviceRequestToAdd.priceInfo = {...deviceRequestToAdd.priceInfo};

                    if (deviceRequestToAdd.priceInfo) {
                        if (MyProductRPricesSelectBaseEnum[deviceRequestToAdd.priceInfo.selectedPrice] !== MyProductRPricesSelectBaseEnum.CUSTOM) {
                            delete deviceRequestToAdd.priceInfo.customPriceInfo;
                        }
                    }
                    projectsRequestedProductsSC.push(deviceRequestToAdd);
                }
            });
        } else {
            // this.dialogModel.project.requestedProductInfo.requestedProducts = [];  // already set above
        }


        // PPU_log console.log(' - processing  warranties and accessories');
        //  =========  now have to be processed warranties and accessories  =========
        // so all noParent items must be added to the projectRequestedProducts


        if (this.dialogModel.isAccessoryOrderRequested) {
            this.dialogModel.availableAccessoryContainers.filter(acc => acc.containerSharedMetadata.addToProductOrderList)
                .forEach(accessoryContainer => {
                    this.containerUtilsService.addWarrantyOrAccessoryContainerToRESTRequestedProducts(accessoryContainer, projectsRequestedProductsSC);
                });
        }
        this.dialogModel.project.accessoryAcquisitionType = AcquisitionTypeEnum[this.dialogModel.isAccessoryOrderRequested ? AcquisitionTypeEnum.PURCHASE : AcquisitionTypeEnum.NONE];


        if (this.dialogModel.isWarrantyOrderRequested) {
            this.dialogModel.availableWarrantyContainers.filter(war => war.containerSharedMetadata.addToProductOrderList)
                .forEach(warrantyContainer => {
                    this.containerUtilsService.addWarrantyOrAccessoryContainerToRESTRequestedProducts(warrantyContainer, projectsRequestedProductsSC);
                });
        }
        this.dialogModel.project.warrantyAcquisitionType = AcquisitionTypeEnum[this.dialogModel.isWarrantyOrderRequested ? AcquisitionTypeEnum.PURCHASE : AcquisitionTypeEnum.NONE];

        if (this.dialogModel.isUpgradesOrderRequested) {
            this.dialogModel.availableUpgradesContainers.filter(lightS => lightS.containerSharedMetadata.addToProductOrderList)
                .forEach(lsContainer => {
                    this.containerUtilsService.addWarrantyOrAccessoryContainerToRESTRequestedProducts(lsContainer, projectsRequestedProductsSC);
                });
        }
        this.dialogModel.project.upgradeAcquisitionType = AcquisitionTypeEnum[this.dialogModel.isUpgradesOrderRequested ? AcquisitionTypeEnum.PURCHASE : AcquisitionTypeEnum.NONE];

        this.dialogModel.project.serviceAcquisitionType = AcquisitionTypeEnum[(this.dialogModel.isDeviceOrderRequested && this.dialogModel.isServiceOrderRequested) ? AcquisitionTypeEnum.PURCHASE : AcquisitionTypeEnum.NONE];

        // ATTENTION: this.dialogModel.project.requestedProductInfo.requestedServiceComment will be handled (cleared if serviceAcquisitionType = NONE) in clearProjectForDealerAppRest (if client changes his mind, then the description should be still available)


        //  ===== requestedSupplyInfo ==========
        // PPU_log console.log(' -  processing supplies', this.dialogModel.project.requestedSupplyInfo);
        this.dialogModel.project.requestedSupplyInfo =
            this.dialogModel.project.requestedSupplyInfo ? this.dialogModel.project.requestedSupplyInfo : new RequestedSupplyInfoModel();

        this.dialogModel.project.requestedSupplyInfo.requestedSupplies = [] as RequestedNotDeviceItemModel[];
        // const projectsRequestedSupplies = this.dialogModel.project.requestedSupplyInfo.requestedSupplies;


        // now the supplies can be processed
        // there are two different main modes, and it depends on this.dialogModel.project.supplyAcquisitionType
        // -- supplyAcquisitionType === PURCHASE, then the this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers and
        //    this.dialogModel.requestedGeneralNoCategorisedSupplyContainers will be processed,
        //
        // -- otherwise supplyAcquisitionType !== PURCHASE the
        //    this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers will be processed


        // at this point we have to filled projectsRequestedSupplies for rest


        if (this.isPrintSmartSupplyAcquisitionType() && !this.someMpsDeviceOrderActive()) {
            this.dialogModel.project.supplyAcquisitionType = EnumUtils.getKeyByValue(SupplyAcquisitionTypeEnum, SupplyAcquisitionTypeEnum.NONE);
        }


        if (this.isSupplyOrderActive()) {
            if (this.isPrintSmartSupplyAcquisitionType()) {
                // console.log('---------------');
                //  refreshRequestedPrintSmartSupplyContainers are updated only when user move from 5.step to 6.step,
                //  so to make them ready to use it must be updated before next step,
                //  ( for data to be successfully converted from containers to project ready for rest project model)
                this.refreshRequestedPrintSmartSupplyContainers();
                this.containersListsUtilsService.addDevicesSuppliesToRequestedSupplies(this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers);
            } else {
                this.refreshAvailablePreselectedGeneralDeviceWithSupplyContainers();
                this.refreshAllRequestedGeneralSupplyContainers();
                this.containersListsUtilsService.addDevicesSuppliesToRequestedSupplies(this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers);
                this.containersListsUtilsService.addNoParentDeviceSupplyContainersToRequestedSupplies(this.dialogModel.requestedGeneralNoCategorisedSupplyContainers);
            }
        } else {
            this.dialogModel.project.requestedSupplyInfo.requestedSupplies = [];
        }

        // PPU_log console.log('collectProjectRequestedInfosForRest finished - project.requestedSupplyInfo', this.dialogModel.project.requestedSupplyInfo);
    }


    public async handleEditModalResult(val: any, dialogRef: IModalDialogV3) {


        const requestedAction = val['requestedAction'];


        // console.log('requestedAction', MyEditModalCloseActionTypeEnum[requestedAction]);

        let response;
        const project = val['project'] as ProjectModel;

        const initialProjectStatus = project.status;
        let keepEditDialogOpened = false;


        // console.log('ttt', project);
        // project.requestedProductInfo.requestedProducts[0].sku='PP';

        try {

            switch (requestedAction) {
                case MyEditModalCloseActionTypeEnum.SAVE_PROJECT:
                case MyEditModalCloseActionTypeEnum.SAVE_AND_GENERATE_QUOTES:
                    // console.log('requestedAction', EnumUtils.getKeyByValue(MyEditModalCloseActionTypeEnum, requestedAction));


                    ProjectModel.updateProjectModelForConsistence(project, false);
                    this.error = ProjectModel.isProjectInvalid(project, this.dialogModel);
                    if (this.error) {
                        // if (this.isProjectInvalid(project)) {
                        console.error('project validation error: ' + this.error.errorMessage);
                        return;
                    }


                    const generateQuotes = requestedAction === MyEditModalCloseActionTypeEnum.SAVE_AND_GENERATE_QUOTES;
                    response = await this.projectService.updateProject(project, generateQuotes);
                    // console.log('update project response', response);


                    if (generateQuotes) {
                        keepEditDialogOpened = true;
                        const quoteDialogRef = this.modalDynamicV3Service
                            .open(QuotesModalComponent, {
                                model: {quotes: response as QuotesModel}
                            });
                        quoteDialogRef.subscribe(async (val2) => {
                            // console.log('quoteDialogRef val', val2);
                            dialogRef.close();

                            const stripRef: IModalDialogV3 = this.modalDynamicV3Service
                                .open(StripModalComponent, {
                                    model: {message: 'Das Angebot wurde erfolgreich versendet.'}
                                });
                            // setTimeout(_ => {
                            //     (stripRef as StripModalComponent).fadeClose();
                            // }, 3000);

                        });
                    }

                    break;

                case MyEditModalCloseActionTypeEnum.SAVE_DRAFT:

                    if (project.id) {
                        response = await this.projectService.updateProjectDraft(project);
                    } else {
                        response = await this.projectService.createProjectDraft(project);

                        this.modalDynamicV3Service
                            .open(StripModalComponent, {
                                model: {message: 'Das neue Projekt wurde erfolgreich gespeichert.'}
                            });
                    }
                    break;

                case MyEditModalCloseActionTypeEnum.SEND_TO_BROTHER:

                    ProjectModel.updateProjectModelForConsistence(project, false);
                    this.error = ProjectModel.isProjectInvalid(project, this.dialogModel);
                    if (this.error) {
                        // if (this.isProjectInvalid(project)) {
                        console.error('project validation error: ' + this.error.errorMessage);
                        return;
                    }

                    const activeProjectStatus = ProjectStatusEnum[project.status];


                    if (activeProjectStatus === ProjectStatusEnum.DRAFT) {
                        project.status = EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum.REQUEST);

                        if (project.id) {
                            response = await this.projectService.updateProjectDraft(project);
                        } else {
                            response = await this.projectService.createProject(project);
                        }

                        this.modalDynamicV3Service
                            .open(StripModalComponent, {
                                model: {message: 'Ihre Anfrage wurde erfolgreich übermittelt.'}
                            });

                    } else {
                        if (activeProjectStatus > ProjectStatusEnum.IN_PROCESS) {
                            console.warn('unexpected project status for merchant user saving request ' + project.status, project);
                        }
                        response = await this.projectService.updateProject(project);
                    }

                    break;

                case MyEditModalCloseActionTypeEnum.SEND_TO_APPROVE:

                    ProjectModel.updateProjectModelForConsistence(project, false);
                    this.error = ProjectModel.isProjectInvalid(project, this.dialogModel);
                    if (this.error) {
                        console.error('project validation error: ' + this.error.errorMessage);
                        return;
                    }
                    project.priceApprovalStatus = EnumUtils.getKeyByValue(PriceApprovalStatusEnum, PriceApprovalStatusEnum.PRICE_APPROVAL_REQUESTED);

                    response = await this.projectService.updateProject(project);
                    break;

                case MyEditModalCloseActionTypeEnum.UNLOCK_PROJECT_LIST_ITEM:
                    // the project list will be reloaded with project unlocked by backend
                    break;
                default:
                    console.error('unexpected edit-modal action', MyEditModalCloseActionTypeEnum[requestedAction]);
            }

            if (!keepEditDialogOpened) {
                dialogRef.close();
            }
        } catch (e) {
            console.error(e);
            project.status = initialProjectStatus;
            console.log('project', project);
            if (e.status === 500) {
                return;  // do nothing, error message is already shown via interceptor
            }
            this.modalDynamicV3Service
                .open(ProjectIsLockedModalComponent, {
                    model: {
                        ...this.translateAndTransformToErrMessageObj(e)
                    }
                });
        }
    }

    public translateAndTransformToErrMessageObj(e): { message: string, errMessage: string } {
        console.warn('trying to handle error: ', e);
        let userName: string;
        let errMessage: string = (e.error && e.error.message) || e;
        if (e.status === 500) {
            errMessage = 'unexpected error occurred';   // do nothing, error message is handled via interceptor
        }

        if (e.status === 400) {
            let reg = errMessage.match(/(Validation failed.*\.)/gi);
            if (reg) {
                if (e.error.errors[0].code === 'NotNull') {
                    errMessage = e.error.errors[0].field + ' is required';

                }

                if (e.error.errors[0].code === 'MinNextBusinessDate') {
                    errMessage = e.error.errors[0].field + ' must be at least next business date';
                }

            }

            const regExpression = new RegExp(/There is no.* contact for industry sector.*zip code (\d+)/, 'gi');  // "There is no contact" or "There is no KAM contact"
            const getArr = regExpression.exec(errMessage);
            if (getArr) {
                return {'message': 'Für diese PLZ konnte kein KAM Kontakt gefunden werden. Bitte wählen Sie eine korrekte PLZ aus.'} as {
                    message: string,
                    errMessage: string
                };
            }

            reg = errMessage.match(/(Some of the brother product was not found by 'sku' value.*\.)/gi);
            if (reg) {
                return {'message': 'Einige der ausgewählten Produkte existieren nicht (mehr) in der Datenbank.'} as {
                    message: string,
                    errMessage: string
                };
            }

            const errorList = e.error?.errors?.map(err => (err.field ? err.field : (err.objectName ? err.objectName : '')) + ': ' + err.code);
            console.log('e', e);

            return {'errMessage': 'unexpected backend error: <br>' + (errorList ? errorList.join('<br>') : (e.error.message || ''))} as {
                message: string,
                errMessage: string
            };
        }

        if (e.status === 403 && e.error.error === 'Forbidden') {
            const strToSearchFor = 'locked by user: ';
            let userNameIndex = e.error.error && e.error.message.indexOf(strToSearchFor);
            userNameIndex = userNameIndex > -1 ? userNameIndex + strToSearchFor.length : 0;
            if (userNameIndex) {
                userName = e.error.message.slice(userNameIndex);
            }

            errMessage = 'Projekt ist gesperrt';

            return {'message': errMessage} as { message: string, errMessage: string };
        }

        return {'errMessage': (e.status ? ('err' + e.status + '<br>') : '') + errMessage} as { message: string, errMessage: string };
    }

    public isInternalUser(): boolean {
        return false;
    }

    public isPrintSmartSupplyAcquisitionType(): boolean {
        return ProjectModel.isPrintSmartSupplyAcquisitionType(this.dialogModel.project);
    }

    public isPrintSmart_SupplyPagePriceAcquisitionTyp(): boolean {
        return ProjectModel.isSupply_PagePriceAcquisitionType(this.dialogModel.project);
    }

    public isSupplyOrderActive(): boolean {
        return this.dialogModel.project && ProjectModel.isSupplyOrderActive(this.dialogModel.project);
    }

    public isNewProject(): boolean {
        return this.dialogModel && this.dialogModel.project && this.dialogModel.project.id === undefined;
    }

    public getDialogModel(): MyDialogDataModel {
        return this.dialogModel;
    }


    /**
     * returns true if Project contains requested devices, accessories or warranties
     * at this point is used only on 3. step so the supplies state is ignored
     */
    public dialogModelContainsSomeRequestedDevicesContainers(): boolean {
        return this.dialogModel && this.dialogModel.containsSomeRequestedDevicesContainers();
    }

    public dialogModelContainsSome4StepContainers(): boolean {
        return this.dialogModel && this.dialogModel.containsSome4StepContainers();
    }


    // called after 5.page dialog is closed by cancel button
    public resetRequestedGeneralSupplyContainersChanges() {

        // requested arrays contains previously selected containers,
        // so go trough available containers, set all to false,
        // the go trough requested and set all to true


        // this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers vs
        // this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers;

        this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers.forEach(deviceContainer => {
            deviceContainer.supplies.forEach(supplyContainer => {
                supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.addTo5stepOrderList = false;
            });
        });

        this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers.forEach(deviceContainer => {
            deviceContainer.supplies.forEach(supplyContainer => {
                supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.addTo5stepOrderList = true;
            });
        });

        // this.dialogModel.availableSuppliesContainers vs.
        // this.dialogModel.requestedGeneralNoCategorisedSupplyContainers;
        this.dialogModel.availableSuppliesContainers.forEach(supplyContainer => {
            supplyContainer.containerSharedMetadata.addToNoCategorised5stepGeneralSupplyOrderList = false;
        });
        this.dialogModel.requestedGeneralNoCategorisedSupplyContainers.forEach(supplyContainer => {
            supplyContainer.containerSharedMetadata.addToNoCategorised5stepGeneralSupplyOrderList = true;
        });
    }

    // called after 3.page dialog is closed by cancel button
    public resetRequestedProductContainersChanges() {
        // set to false all containers which has been changed
        // requested arrays contains all items which was previously selected
        // so go through available arrays, set all of them to false and then set all fo requested back to true value
        this.dialogModel.availableDevicesContainers
            .filter(container => container.containerSharedMetadata.addToProductOrderList === true)
            .forEach(container => {
                container.containerSharedMetadata.addToProductOrderList = false;
            });
        // go through all containers which are already in requested list
        // and return their table present state to the true value;
        this.dialogModel.requestedDevicesContainers.forEach(deviceContainer => {
            deviceContainer.containerSharedMetadata.addToProductOrderList = true;
        });

        this.dialogModel.availableAccessoryContainers
            .filter(container => container.containerSharedMetadata.addToProductOrderList === true)
            .forEach(container => {
                container.containerSharedMetadata.addToProductOrderList = false;
            });
        this.dialogModel.requestedAccessoryContainers.forEach(container => {
            container.containerSharedMetadata.addToProductOrderList = true;
        });

        this.dialogModel.availableWarrantyContainers
            .filter(container => container.containerSharedMetadata.addToProductOrderList === true)
            .forEach(container => {
                container.containerSharedMetadata.addToProductOrderList = false;
            });
        this.dialogModel.requestedWarrantyContainers.forEach(container => {
            container.containerSharedMetadata.addToProductOrderList = true;
        });
    }


    /**
     *  used on 5. dialog page
     *  check all printSmart devices in availablePreselectedPrintSmartDevicesWithSupplyContainers
     *  and if they are mark for supply order, and contains any supply
     *  then puts them to requestedPreselectedPrintSmartDevicesWithSupplyContainers arr. to display it on 6.page
     *  note: availablePreselectedPrintSmartDevicesWithSupplyContainers contains printSmart devices already selected on 3.page ( so there is not all printSmarts )
     */

    public refreshRequestedPrintSmartSupplyContainers(): void {
        // PPU_log console.log('refreshRequestedPrintSmartSupplyContainers starts');
        this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers = [] as MyDeviceRequestContainerModel[];
        if (SupplyAcquisitionTypeEnum [this.dialogModel.project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.NONE) {
            return;
        }
        if (SupplyAcquisitionTypeEnum [this.dialogModel.project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT) {
            this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers = [] as MyDeviceRequestContainerModel[];
            this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.forEach(deviceContainer => {
                if (deviceContainer.mpsSupplies?.length > 0) {
                    // precess if some supply for current device is defined (by rest, it is not about user input)
                    const deviceContainerFlatCopy = Object.assign({}, deviceContainer);
                    // add supplies if amount is defined or even if amount is 0 and project status is draft to allow planing
                    // it means there is possible to order supply for printsmarts event the amount of printsmart is set to 0 on 3.dp

                    // deviceContainerFlatCopy.mpsSupplies = deviceContainerFlatCopy.mpsSupplies.filter(supplyContainer =>
                    //     supplyContainer.parentPrintSmartDedicatedSupplyAmount.amount > 0 ||
                    //     (ProjectStatusEnum[this.dialogModel.project.status] === ProjectStatusEnum.DRAFT &&
                    //         supplyContainer.parentPrintSmartDedicatedSupplyAmount.amount === 0));

                    //  ..... supplyContainer.parentPrintSmartDedicatedSupplyAmount = new MyProductAmountModel();

                    if (deviceContainerFlatCopy.mpsSupplies?.length > 0) {
                        // if device still contains some supplies, should be added to requestedPreselectedPrintSmartDevicesWithSupplyContainers to be displayed on dialog 6.page
                        this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers.push(deviceContainerFlatCopy);
                    }
                }
            });
            // console.log('refreshRequestedPrintSmartSupplyContainers finished1', this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers);
            return;
        }

        if (this.isPrintSmart_SupplyPagePriceAcquisitionTyp()) { // MPS_BASED_ON_PAGE_PRICE

            // in this case the supplies is not involved, and only page prices are defined, the real supply delivery will be calculated by this amounts
            // for this case this is still processed like some sort of supply. The data for this case are stored in deviceContainer.devicePricePerPage
            // but only for internal user, for merchant user they are not defined because is useless (merchant user do not see the prices and so on)

            // === old code: - by new spec the user have no choice and for all mps device will be supplies ordered, so the filter is now removed
            // changed for https://minntgmbh.atlassian.net/browse/BROT-1047
            // this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.filter(deviceContainer =>
            //     deviceContainer.containerSharedMetadata.addToRequestedPrintSmartDeviceSupplyOrderList
            // ).forEach(deviceContainer => {
            // === old code ends
            this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.forEach(deviceContainer => {
                const deviceContainerFlatCopy = Object.assign({}, deviceContainer);
                deviceContainerFlatCopy.supplies = [];

                //  changed for https://minntgmbh.atlassian.net/browse/BROT-1047
                // by new spec the check box which was connected with the addToRequestedPrintSmartDeviceSupplyOrderList
                // was removed from dialog, so the field must be set to true or
                // completely removed
                // deviceContainer.containerSharedMetadata.addToRequestedPrintSmartDeviceSupplyOrderList = true;


                this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers.push(deviceContainerFlatCopy);
            });
            // PPU_log console.log('refreshRequestedPrintSmartSupplyContainers finished2', this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers);
            return;
        }

        console.error('refreshRequestedPrintSmartSupplyContainers  - unexpected MPS supplyAcquisitionType: ' + this.dialogModel.project.supplyAcquisitionType, this.dialogModel.project);


    }


    // used on 5. dialog page initializing, to collect left tab table items which should be displayed in this table
    // filter all from 3.page table, the selected printSmart devices with mpsSupplies and add them  to availablePreselectedPrintSmartDevicesWithSupplyContainers
    // the availablePreselectedPrintSmartDevicesWithSupplyContainers is directly displayed on 5.page dialog ( not as other availableContainerLists), so even they are not ordered by user,
    // they must be ready to work with, so DevicePricePerPage must be initialized for newly added devices.
    // and by new spec all MPSPerPage must be ordered with supplies so the merchant user have no choice
    public refreshAvailablePreselectedPrintSmartDeviceWithSupplyContainers(): void {

        // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        // PPU_log console.log('refreshAvailablePreselectedPrintSmartDeviceWithSupplyContainers starts');
        // PPU_log console.log(' - requestedDevicesContainers to process:', this.dialogModel.requestedDevicesContainers);

        // let mpsSuppliesFound = false;
        this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers = [];
        if (!this.dialogModel.isDeviceOrderRequested) {
            return;
        }
        if (this.dialogModel.requestedDevicesContainers) {
            // add printSmart containers to availablePreselectedPrintSmartDevicesWithSupplyContainers
            // the output depends on requested devices from 3.dialog page, so there the output will  be the selected printSmart devices with supplies
            // so add all MPS devices with some supplies to availablePreselectedPrintSmartDevicesWithSupplyContainers array, which will be displayed on 5. page for MPS modes
            this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers =
                this.dialogModel.requestedDevicesContainers.filter(productContainer => productContainer.itemToOrder.printSmart
                    && productContainer?.mpsSupplies?.length > 0);


            // go through reinitialized availablePreselectedPrintSmartDevicesWithSupplyContainers
            // array and check all fields if they are ready to work with otherwise init them
            this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.forEach(deviceContainer => {
                deviceContainer.mpsSupplies.forEach(mpsSupplyContainer => {

                    // maybe some amount lock func should be implemented to avoid rewriting users input, otherwise the by user already entered values
                    // will be re-write by default values, logic will be provided by Wassim if will be necessary
                    // note: supply amount is stored out of supplyRequest, so the init order not matter
                    this.containerUtilsService.calculateMPSSuppliesAmount(mpsSupplyContainer, this.dialogModel.project);

                    mpsSupplyContainer.containerSharedMetadata.printSmartSupplyTableEditableRowIndex = null;
                    this.containerUtilsService.initSupplyContainers_SupplyRequest(mpsSupplyContainer);
                });
            });


            // set editRowIndex
            let index = 0;

            // updated printSmartSupplyTableEditableRowIndex, which helps control/distinguish which supply price row input will be editable
            // containerSharedMetadata is shared between rows and same sku items and will be set only for first time occurrence
            for (let i = 0; i < this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.length; i++) {
                this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers[i].mpsSupplies.forEach(mpsSupplyContainer => {
                    if (mpsSupplyContainer.containerSharedMetadata.printSmartSupplyTableEditableRowIndex === null) {
                        index = i;
                        mpsSupplyContainer.containerSharedMetadata.printSmartSupplyTableEditableRowIndex = index;
                    }
                });
            }

        }
        // PPU_log console.log('refreshAvailablePreselectedPrintSmartDeviceWithSupplyContainers done, all MPSSuppliesAmount was recalculated');
        // PPU_log console.log(' - this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers', this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers);

        // so now the availablePreselectedPrintSmartDevicesWithSupplyContainers array is ready to work with on 5. dialog page
    }


    /**
     * refresh availablePreselectedGeneralDevicesWithSupplyContainers array ,
     * which is array of devices which has some supplies connected with and thous devices are also selected for order on 3.page,
     * so it will check all device container in requestedDevicesContainers array and thous MFC and PRINTER
     * which have some supplies will add to availablePreselectedGeneralDevicesWithSupplyContainers array,
     * refreshAvailablePreselectedGeneralDeviceWithSupplyContainers is later use to select supplies for selected device from to order thous supplies
     * it meas that thous supplies must be redy to work with, so there tohous supplies are aslo intitalized to work with
     */
    public refreshAvailablePreselectedGeneralDeviceWithSupplyContainers(): void {
        this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers = [];
        if (!this.dialogModel.isDeviceOrderRequested) {
            return;
        }
        if (this.dialogModel.requestedDevicesContainers) {
            // add requested devices with supplies to availablePreselectedGeneralDevicesWithSupplyContainers
            this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers =
                this.dialogModel.requestedDevicesContainers.filter(productContainer =>
                        productContainer?.supplies?.length > 0
                        && (ProductCategoryTypeEnum[productContainer.itemToOrder.category] === ProductCategoryTypeEnum.MFC
                            || ProductCategoryTypeEnum[productContainer.itemToOrder.category] === ProductCategoryTypeEnum.PRINTER
                        )
                );


            // init supply containers to be ready to work with
            this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers.forEach(device => {
                device.supplies.forEach(supplyContainer => {
                    if (!supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata) {
                        supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata = new MyContainerDeviceDedicatedSupplyMetadata();
                    }
                    // attention: do not null the variable directly, it is shared with printSmart supply arrays and in fact contains rPrices only
                    // supplyContainer.notDeviceRequest = null;
                    // so by new spec there will be only selected devices, so the amount will be small, so we can init notDeviceRequest even it will not be used

                    this.containerUtilsService.initSupplyContainers_SupplyRequest(supplyContainer);
                });
            });
        }
    }


    /**
     * used on 5. dialog page to handle result of add supplies "kaufen" dialog
     * we have two arrays containing supplies:
     * - availablePreselectedGeneralDevicesWithSupplyContainers (contains devices which contains supplies) and
     * - availableSuppliesContainers (contains all supplies (with and without device parents) )
     * the supplies dialog works with 2 arrays:
     * - requestedPreselectedGeneralDevicesWithSupplyContainers - allow select supplies for already chosen devices
     * - availableSuppliesContainers - allow select supplies no matter if it has parent device or if its parent is preselected, in short any supply
     * this dialog only set the property addToNoCategorised5StepGeneralSupplyOrderList to true, is should be visible on 5.dialog page table
     * so now we have to filter the  selected containers and add them to requestedPreselectedGeneralDevicesWithSupplyContainers and requestedGeneralNoCategorisedSupplyContainers
     * which content is displayed on 5.page dialog
     */

    public refreshAllRequestedGeneralSupplyContainers(): void {

        // console.log('refreshAllRequestedGeneralSupplyContainers', this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers);


        this.dialogModel.requestedGeneralNoCategorisedSupplyContainers = [];
        if (this.dialogModel.availableSuppliesContainers) {
            this.dialogModel.requestedGeneralNoCategorisedSupplyContainers =
                this.dialogModel.availableSuppliesContainers.filter(supplyContainer => {
                    return supplyContainer.containerSharedMetadata.addToNoCategorised5stepGeneralSupplyOrderList;
                });
        }

        // make filtered supply containers ready to work with on 5. step  dialog and clear generalSupplyTableEditableRowIndex
        // generalSupplyTableEditableRowIndex is used to distinguish first usage of this item in dialog table, because only first usage has price editable
        this.dialogModel.requestedGeneralNoCategorisedSupplyContainers.forEach(supplyContainer => {
            if (supplyContainer.noParentGeneralSupplyAmount === null) {
                supplyContainer.noParentGeneralSupplyAmount = new MyProductAmountModel();
            }
            this.containerUtilsService.initSupplyContainers_SupplyRequest(supplyContainer);
            supplyContainer.containerSharedMetadata.generalSupplyTableEditableRowIndex = null;
        });

        let index = 0;

        // process supplies connected with parent device, it means supplies which are on dialog categorised by its parent device and this parent device must me preselected on 3.page dialog
        this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers = [];
        if (this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers) {
            this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers.forEach(deviceContainer => {
                const deviceContainerFlatCopy = Object.assign({}, deviceContainer);
                // add only selected supplies
                deviceContainerFlatCopy.supplies = deviceContainerFlatCopy.supplies.filter(supplyContainer => {
                    supplyContainer.containerSharedMetadata.generalSupplyTableEditableRowIndex = null;
                    return supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.addTo5stepOrderList;
                });

                if (deviceContainerFlatCopy.supplies?.length > 0) {
                    deviceContainerFlatCopy.supplies.forEach(supplyContainer => {
                        if (supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata === null) {
                            supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata = new MyContainerDeviceDedicatedSupplyMetadata();
                        }
                    });

                    deviceContainerFlatCopy.supplies.forEach(supplyContainer => {
                        this.containerUtilsService.initSupplyContainers_SupplyRequest(supplyContainer);

                        if (supplyContainer.parent.itemToOrder.printSmart) {

                            // const newAmount = this.containerUtilsService.getRecommendedSupplyAmount(supplyContainer, this.dialogModel.project);
                            //
                            // if (Number.isFinite(supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount) &&
                            //     newAmount !== supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount) {
                            //     // PPU_log console.log(supplyContainer.parent.itemToOrder.sku + ' / ' + supplyContainer.itemToOrder.sku +
                            //     //     '  - recallculated supply amount:' + newAmount + ' differ from old value ',
                            //     //     supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount);
                            // } else {
                            //     supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount = newAmount;
                            // }

                            if (!Number.isFinite(supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount)) {
                                // if amount is not defined, calculate it
                                const newAmount = this.containerUtilsService.getRecommendedSupplyAmount(supplyContainer, this.dialogModel.project);
                                supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount = newAmount;
                            }
                        }

                    });

                    this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers.push(deviceContainerFlatCopy);
                }
            });


            // updated generalSupplyTableEditableRowIndex, which helps control/distinguish which supply price row input will be editable
            for (let i = 0; i < this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers.length; i++) {
                this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers[i].supplies.forEach(supplyContainer => {
                    if (supplyContainer.containerSharedMetadata.generalSupplyTableEditableRowIndex === null) {
                        index = i;
                        supplyContainer.containerSharedMetadata.generalSupplyTableEditableRowIndex = index;
                    }
                });
            }

        }

        this.announceTableContentChanged(MyContainersTableIdEnum.step5TableContainers);
        // PPU_log console.log('refreshAllRequestedGeneralSupplyContainers finished', this.dialogModel.availablePreselectedGeneralDevicesWithSupplyContainers);
    }


    // public getNextWorkingDateAsMinDayString(minDay?: Date): string {
    //     return DateTimeUtils.getNextWorkingDateAsMinDayString(minDay);
    // }

    public getNextWorkingDate(minDay?: Date): Date {
        return DateTimeUtils.getNextWorkingDate(minDay);
    }

    // public getNext5YearsAsMaxDayString(): string {
    //     return DateTimeUtils.getNext5YearsAsMaxDayString();
    // }

    public getNext5YearsDate(): Date {
        return DateTimeUtils.getNext5YearsDate();
    }

    private getProductBySku(sku): ProductModel {
        return this.dialogModel.products.find(product => product.sku === sku);
    }

    // usage example:  [ngClass]="{'notify-change' : notifyChange( pUNFEnum.COMPANY_NAME)}"
    /**
     &.notify-change {
     background: $light-khaki !important;
     }
     **/
    public showChangeNotification(fieldId: ProjectUpdateNotificationFieldEnum): boolean {
        // remove financial_system condition, its only for developing purpose to force notification to all processed fields
        // if (this.dialogModel.project.industrySector === 'FINANCIAL_SYSTEM') {
        //     return true;
        // }

        if (this.dialogModel?.project?.updateNotificationDetails?.length > 0) {
            return this.dialogModel.project.updateNotificationDetails.some(fId => ProjectUpdateNotificationFieldEnum[fId] === fieldId);
        } else {
            return false;
        }
    }

    /**
     *  retrieves the name of the current product distributor based on the productDistributorId in the requestedProductInfo object.
     *  If it can't find the distributor or if the requestedProductInfo object doesn't exist, it returns null.
     */
    public getCurrentProductDistributorName(): string {
        if (this.dialogModel.project.requestedProductInfo?.productDistributorId) {
            if (this.dialogModel.currentProductDistributor?.id !== this.dialogModel.project.requestedProductInfo.productDistributorId) {
                this.dialogModel.currentProductDistributor = this.dialogModel.productDistributors.find(distributor =>
                    distributor.id === this.dialogModel.project.requestedProductInfo.productDistributorId);
            }
            if (this.dialogModel?.currentProductDistributor) {
                return this.dialogModel.currentProductDistributor.name + this.getDistributorStatusHtml(this.dialogModel.currentProductDistributor?.status);
            }

        }
        return null;
    }

    public getCurrentSecondaryProductDistributorName(): string {
        if (this.dialogModel.project.requestedProductInfo?.secondaryProductDistributorId) {
            if (this.dialogModel.currentSecondaryDistributor?.id !== this.dialogModel.project.requestedProductInfo.secondaryProductDistributorId) {
                this.dialogModel.currentSecondaryDistributor = this.dialogModel.productDistributors.find(distributor =>
                    distributor.id === this.dialogModel.project.requestedProductInfo.secondaryProductDistributorId);
            }
            if (this.dialogModel?.currentSecondaryDistributor) {
                return this.dialogModel.currentSecondaryDistributor?.name + this.getDistributorStatusHtml(this.dialogModel.currentSecondaryDistributor?.status);
            }

        }
        return null;
    }

    private getDistributorStatusHtml(status: string): string {
        if (ProjectDistributorStatusEnum[status] === ProjectDistributorStatusEnum.INACTIVE) {
            return ' <b>(inaktiv)</b>';
        }
        return '';
    }


    public getCurrentSupplyDistributorName(): string {
        if (this.dialogModel.project.requestedSupplyInfo && this.dialogModel.project.requestedSupplyInfo.supplyDistributorId) {
            const currentSupplyDistributorId = this.dialogModel.currentSupplyDistributor?.id;
            if (!currentSupplyDistributorId || this.dialogModel.project.requestedSupplyInfo.supplyDistributorId !== currentSupplyDistributorId) {
                this.dialogModel.currentSupplyDistributor = this.dialogModel.supplyDistributors.find(distributor =>
                    distributor.id === this.dialogModel.project.requestedSupplyInfo.supplyDistributorId);
            }
            return this.dialogModel.currentSupplyDistributor.name + this.getDistributorStatusHtml(this.dialogModel.currentSupplyDistributor?.status);
        }
        return null;
    }

    public getCurrentSecondarySupplyDistributorName(): string {
        if (this.dialogModel.project.requestedSupplyInfo && this.dialogModel.project.requestedSupplyInfo.secondarySupplyDistributorId) {
            const currentSecondarySupplyDistributorId = this.dialogModel.currentSecondarySupplyDistributor?.id;
            if (!currentSecondarySupplyDistributorId || this.dialogModel.project.requestedSupplyInfo.secondarySupplyDistributorId !== currentSecondarySupplyDistributorId) {
                this.dialogModel.currentSecondarySupplyDistributor = this.dialogModel.supplyDistributors.find(distributor =>
                    distributor.id === this.dialogModel.project.requestedSupplyInfo.secondarySupplyDistributorId);
            }
            return this.dialogModel.currentSecondarySupplyDistributor.name + this.getDistributorStatusHtml(this.dialogModel.currentProductDistributor?.status);
        }
        return null;
    }


    public updateMPSSuppliesAmounts() {
        console.log('updateMPSSuppliesAmounts, all MPSSuppliesAmounts was recalculated');

        this.dialogModel.availablePreselectedPrintSmartDevicesWithSupplyContainers.forEach(printSmartDeviceContainer => {
            printSmartDeviceContainer.supplies.forEach(supplyContainer => {
                this.containerUtilsService.calculateMPSSuppliesAmount(supplyContainer, this.dialogModel.project);
            });
        });
    }

    public updateGeneralSuppliesAmounts() {


        const containersToUpdate = this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers.filter(deviceContainer => deviceContainer.itemToOrder.printSmart);
        // PPU_log console.log('containersToUpdate', containersToUpdate);


        this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers.filter(deviceContainer => deviceContainer.itemToOrder.printSmart)
            .forEach(printSmartDeviceContainer => {
                printSmartDeviceContainer.supplies.forEach(supplyContainer => {
                    const recommendedSupplyAmount = this.containerUtilsService.getRecommendedSupplyAmount(supplyContainer, this.dialogModel.project);
                    supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount = Number.isFinite(recommendedSupplyAmount) ? recommendedSupplyAmount : supplyContainer.parentDeviceDedicatedGeneralSupplyMetadata.amount;
                });
            });

        console.log('updateGeneralSuppliesAmounts, all amounts was recalculated', containersToUpdate);
    }

    public set5pageSuppliesPrices() {

        // console.log('[2] this.dialogModel', this.dialogModel);

        switch (SupplyAcquisitionTypeEnum[this.dialogModel.project.supplyAcquisitionType]) {
            case  SupplyAcquisitionTypeEnum.PURCHASE:
                this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers.forEach(deviceContainer => {
                    deviceContainer.supplies.forEach(supplyContainer => {
                        this.containerUtilsService.setRecommendedSupplyPrice(supplyContainer);
                    });
                });
                this.dialogModel.requestedGeneralNoCategorisedSupplyContainers.forEach(supplyContainer => {
                    this.containerUtilsService.setRecommendedSupplyPrice(supplyContainer);

                });
                break;
            case  SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE:
                this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers.forEach(deviceContainer => {
                    this.containerUtilsService.setRecommendedDevicePagePrice(deviceContainer, RPriceIdentifierEnum.DEFAULT_PAGE_PRICE);
                });
                break;
            case  SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT:
                this.dialogModel.requestedDevicesContainers.forEach(deviceContainer => {
                    deviceContainer.mpsSupplies.forEach(supplyContainer => {
                        this.containerUtilsService.setRecommendedSupplyPrice(supplyContainer);
                    });
                });
                break;
            default:
            // do something
        }

    }

    public set3pageSuppliesPrices() {

        // console.log('[3] this.dialogModel', this.dialogModel);

        this.dialogModel.requestedDevicesContainers.forEach(deviceContainer => {
            this.containerUtilsService.setRecommendedDAWPrice(deviceContainer);
        });
        this.dialogModel.requestedAccessoryContainers.forEach(accessoryContainer => {
            this.containerUtilsService.setRecommendedDAWPrice(accessoryContainer);
        });

        this.dialogModel.requestedWarrantyContainers.forEach(warrantyContainer => {
            this.containerUtilsService.setRecommendedDAWPrice(warrantyContainer);
        });


    }

// =======  methods used in components directly ends  =======

    /**
     * update onRPricesBasedApprovalStatusDetailsHelper, will be set to true if project contains any approvable price
     */
    public updateRPricesBasedApprovalStatusDetailsHelper() {


        let result = false;

        result =
            (this.dialogModel.isDeviceOrderRequested &&
                this.dialogModel.requestedDevicesContainers.some(deviceContainer => this.isContainerRPriceApprovalRequested(deviceContainer, RPriceIdentifierEnum.R7))) ||
            (this.dialogModel.isAccessoryOrderRequested &&
                this.dialogModel.requestedAccessoryContainers.some(accContainer => this.isContainerRPriceApprovalRequested(accContainer, RPriceIdentifierEnum.R7))) ||
            (this.dialogModel.isWarrantyOrderRequested &&
                this.dialogModel.requestedWarrantyContainers.some(warrantyContainer => this.isContainerRPriceApprovalRequested(warrantyContainer, RPriceIdentifierEnum.R7))) ||
            (this.dialogModel.isUpgradesOrderRequested &&
                this.dialogModel.requestedUpgradesContainers.some(lsContainer => this.isContainerRPriceApprovalRequested(lsContainer, RPriceIdentifierEnum.R7)));

        // if (result) {
        //     console.log('approval requested for page 3: dev=' +
        //         this.dialogModel.requestedDevicesContainers.some(deviceContainer => this.isContainerRPriceApprovalRequested(deviceContainer, RPriceIdentifierEnum.R7)) + ', acc=' +
        //         this.dialogModel.requestedAccessoryContainers.some(accContainer => this.isContainerRPriceApprovalRequested(accContainer, RPriceIdentifierEnum.R7)) + ', war= ' +
        //         this.dialogModel.requestedWarrantyContainers.some(warrantyContainer => this.isContainerRPriceApprovalRequested(warrantyContainer, RPriceIdentifierEnum.R7)));
        // }

        if (!result) {
            switch (SupplyAcquisitionTypeEnum[this.dialogModel.project.supplyAcquisitionType]) {
                case SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE:
                    // return result;
                    break;
                case SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT:
                    result = this.dialogModel.requestedPreselectedPrintSmartDevicesWithSupplyContainers.some(deviceContainer => this.isApprovalRequestedForSomeContainerChildren(deviceContainer, RPriceIdentifierEnum.R5));

                    break;
                case SupplyAcquisitionTypeEnum.PURCHASE:
                    result = this.dialogModel.requestedPreselectedGeneralDevicesWithSupplyContainers.some(deviceContainer => this.isApprovalRequestedForSomeContainerChildren(deviceContainer, RPriceIdentifierEnum.R5)) ||
                        this.dialogModel.requestedGeneralNoCategorisedSupplyContainers.some(deviceContainer => this.isContainerRPriceApprovalRequested(deviceContainer, RPriceIdentifierEnum.R5));
                    break;
                case SupplyAcquisitionTypeEnum.NONE:
                    break;
                default:
                    console.warn('unexpected supplyAcquisitionType');
            }

        }

        this.dialogModel.onRPricesBasedApprovalStatusDetailsHelper = result ? PriceApprovalStatusEnum.PRICE_APPROVAL_REQUESTED : null;
        // console.log('updateRPricesBasedApprovalStatusDetailsHelper - onRPricesBasedApprovalStatusDetailsHelper = ', ProjectStatusDetailsEnum[this.dialogModel.onRPricesBasedApprovalStatusDetailsHelper]);
    }


    private isContainerRPriceApprovalRequested(container: MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel, highestRPriceIdentifierWithoutApproval: RPriceIdentifierEnum) {
        let result = false;
        let itemPriceInfo: PriceInfoModel;
        // let isDevice: boolean;

        if ((container as MyDeviceRequestContainerModel).isDevice) {
            // isDevice = true;
            itemPriceInfo = (container as MyDeviceRequestContainerModel).deviceRequest.priceInfo;
        } else {
            // isDevice = false;
            itemPriceInfo = (container as MyNotDeviceRequestContainerModel).notDeviceRequest.priceInfo;
        }


        const selectedPrice = RPriceIdentifierEnum[itemPriceInfo.selectedPrice];


        if (highestRPriceIdentifierWithoutApproval < selectedPrice && selectedPrice !== RPriceIdentifierEnum.CUSTOM) {
            return true;
        }
        if (selectedPrice === RPriceIdentifierEnum.CUSTOM) {
            const highestRPriceWithoutApproval = itemPriceInfo.rPriceInfo.find(rpi => RPriceIdentifierEnum[rpi.rPriceIdentifier] === highestRPriceIdentifierWithoutApproval);
            const itemCustomPrice = itemPriceInfo.customPriceInfo.customPrice;

            result = +itemCustomPrice < +highestRPriceWithoutApproval.rPrice;
        }
        return result;
    }

    private isApprovalRequestedForSomeContainerChildren(container: MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel, highestRPriceIdentifierWithoutApproval: RPriceIdentifierEnum): boolean {
        let result = false;

        switch (SupplyAcquisitionTypeEnum[this.dialogModel.project.supplyAcquisitionType]) {
            case SupplyAcquisitionTypeEnum.MPS_BASED_ON_PAGE_PRICE:
                break;
            case SupplyAcquisitionTypeEnum.MPS_BASED_ON_UNIT_COUNT:
                result = (container as MyDeviceRequestContainerModel).mpsSupplies.some(supply => this.isContainerRPriceApprovalRequested(supply, highestRPriceIdentifierWithoutApproval));
                break;
            case SupplyAcquisitionTypeEnum.PURCHASE:
                result = (container as MyDeviceRequestContainerModel).supplies.some(supply => this.isContainerRPriceApprovalRequested(supply, highestRPriceIdentifierWithoutApproval));
                break;
        }


        return result;

    }

    private getCopyProject(project: ProjectModel) {
        return ObjectsUtils.deepCopy(project);
    }

    /**
     * returns 0 if the has same content, otherwise result > 0, output number only indicates where the difference was found for debug purpose
     * @param obj1
     * @param obj2
     */
    public compareProjectsAsObjects(obj1, obj2): number {

        const debug = false;
        // return JSON.stringify(obj1) === JSON.stringify(obj2) ? 0 : 1;

        // Handle the 3 simple types, and null or undefined
        // if (null == obj1 || "object" != typeof obj) return false;
        if (typeof obj1 !== typeof obj2) {
            return 1;
        }

        if (obj1 instanceof Date) {
            if (obj1.getTime() !== obj2.getTime()) {
                return 15;
            } else {
                return 0;
            }
        }

        // const test = typeof obj1;

        if ('object' !== typeof obj1) {
            if (obj1 !== obj2) {
                return 2;
            } else {
                return 0;
            }

        } else {
            // handle Array
            if (obj1 === null && obj2 === null) {
                return 0;
            }

            if (obj1 === null) {
                if (obj2 instanceof Array && obj2.length === 0) {
                    // for brother purpose the arrays match
                    return 0;
                }
                return 8;
            }
            if (obj2 === null) {
                if (obj2 instanceof Array && obj1.length === 0) {
                    // for brother purpose the arrays match
                    return 0;
                }
                return 9;
            }

            if (obj1 instanceof Array) {
                if (debug) {
                    // console.log('================================== is array');
                }
                const result = this.compareArrays(obj1, obj2);
                if (result > 0) {
                    return result;
                }
            }

            let state: number;
            // handle Object
            if (obj1 instanceof Object && obj2 instanceof Object) {

                // next test is not working if some of the attribute has null value in one object and is not defined in second object
                // if ((Object.keys(obj1) as Array<keyof typeof obj1>).length !== (Object.keys(obj2) as Array<keyof typeof obj2>).length) {
                //
                //     return 5;
                // }

                // tslint:disable-next-line:forin
                for (const attr in obj1) {
                    if (debug) {
                        console.log('attr', attr);
                    }

                    if (obj1.hasOwnProperty(attr) && obj2.hasOwnProperty(attr)) {

                        switch (attr) {
                            case 'priceInfo':
                                const prInfo1 = obj1[attr] as PriceInfoModel;
                                const prInfo2 = obj2[attr] as PriceInfoModel;
                                if (prInfo1.selectedPrice !== prInfo2.selectedPrice) {
                                    return 7;
                                }

                                if (prInfo1.selectedPrice === RPriceIdentifierEnum[RPriceIdentifierEnum.CUSTOM]) {
                                    state = this.compareProjectsAsObjects(prInfo1, prInfo2);
                                    if (state > 0) {
                                        return 10;
                                    }
                                }
                                break;
                            case 'requestedProducts':
                            case 'requestedSupplies':
                            case 'parentSkuMapping':

                                state = this.compareArrays(obj1[attr], obj2[attr], 'sku', attr);
                                if (state > 0) {
                                    if (debug) {
                                        console.log('obj1/array is different ' + attr, obj1[attr]);
                                    }
                                    if (debug) {
                                        console.log('- to obj2/' + attr, obj2[attr]);
                                    }
                                    return 300 + state;
                                }
                                break;

                            case 'offerTextModules':
                            case 'tenderDocuments':
                                if (obj1['id']) {
                                    state = this.compareArrays(obj1[attr], obj2[attr], 'id', attr);
                                }
                                if (state > 0) {
                                    return 11;
                                }
                                break;

                            case 'innendienstContacts':
                            case 'kamContacts':
                            case 'updateNotificationDetails':

                                // testing is not needed , those fields do not contains data from user
                                return 0;

                            default:
                                if (debug) {
                                    console.log('default test =====>>>  attr', attr);
                                }
                                state = this.compareProjectsAsObjects(obj1[attr], obj2[attr]);
                                if (state > 0) {
                                    if (debug) {
                                        console.log('obj1/attr is different ' + attr, obj1[attr]);
                                        console.log('- to obj2/' + attr, obj2[attr]);
                                    }
                                    return 200 + state;
                                }
                        }

                    } else if ((obj1[attr] === null || obj1[attr] === undefined) && (obj2[attr] === null || obj2[attr] === undefined)) {
                        return 0;
                    } else {
                        if (attr === 'isPrintSmart') {
                            // testing is not needed , those fields do not contains data from user
                            return 0;
                        }
                        return 6;
                    }
                }
                return 0;
            }
        }


        console.warn('Unable to compare object Its type isn\'t supported.', obj1);
        return 100;
    }

    private compareArrays(arr1: any[], arr2: any[], idKey: string = null, placeId: string = null) {
        // console.log(placeId + ' - going to test array', arr1);
        if (arr1.length !== arr2.length) {
            return 3;
        }

        if (arr1.length === 0) {
            return 0;
        }

        if (idKey) {
            arr1.sort((a, b) => {
                return a[idKey] > b[idKey] ? -1 : a[idKey] === b[idKey] ? 0 : 1;
            });
            // console.log('arr1 sorted by ' + idKey, arr1);

            arr2.sort((a, b) => {
                return a[idKey] > b[idKey] ? -1 : a[idKey] === b[idKey] ? 0 : 1;
            });
            // console.log('arr2 sorted by ' + idKey, arr2);
        }

        for (let i = 0, len = arr1.length; i < len; i++) {

            const state = this.compareProjectsAsObjects(arr1[i], arr2[i]);
            if (state > 0) {

                // console.log('array is different ' + i, arr1);
                // console.log('- to ', arr2);
                return 100 + state;
            }
        }
        return 0;
    }

    public someMpsDeviceOrderActive(): boolean {
        return this.dialogModel.requestedDevicesContainers.some(deviceContainer => deviceContainer.itemToOrder.printSmart);
    }

    public getRolloutStartMinDay() {
        const nextWorkingDate = this.getNextWorkingDate();
        if (!this.dialogModel.project.quoteClosingDate) {
            return nextWorkingDate;
        } else {
            const quoteClosingDate_NextWorkingDay = this.getNextWorkingDate(this.dialogModel.project.quoteClosingDate);
            return nextWorkingDate > quoteClosingDate_NextWorkingDay ? nextWorkingDate : quoteClosingDate_NextWorkingDay;
        }
    }

    public getRolloutEndMinDate(rolloutStart: Date) {

        if (rolloutStart) {
            return this.getNextWorkingDate(rolloutStart);
        }

        if (this.dialogModel.project.quoteClosingDate) {
            return this.getNextWorkingDate(this.dialogModel.project.quoteClosingDate);
        }

        return this.getNextWorkingDate();
    }

    public async updateProjectWidgetContact(project?: ProjectModel) {

        const tmpProject = project ? project : this.dialogModel && this.dialogModel.project;

        if (tmpProject && tmpProject.company) {
            await this.projectsContactsWidgetService.refreshProjectKamContact({  // should not be awaited
                industrySector: tmpProject.industrySector,
                companyZip: tmpProject.company.zip,
                country: tmpProject.company.country
            });
        }
    }

    private reinitProductsRequiredFlags(dialogModel: MyDialogDataModel) {
        dialogModel.isDeviceOrderRequested = dialogModel.project.hardwareAcquisitionType === AcquisitionTypeEnum[AcquisitionTypeEnum.PURCHASE];
        dialogModel.isAccessoryOrderRequested = dialogModel.project.accessoryAcquisitionType === AcquisitionTypeEnum[AcquisitionTypeEnum.PURCHASE];
        dialogModel.isWarrantyOrderRequested = dialogModel.project.warrantyAcquisitionType === AcquisitionTypeEnum[AcquisitionTypeEnum.PURCHASE];
        dialogModel.isServiceOrderRequested = dialogModel.project.serviceAcquisitionType === AcquisitionTypeEnum[AcquisitionTypeEnum.PURCHASE];
        dialogModel.isUpgradesOrderRequested = dialogModel.project.upgradeAcquisitionType === AcquisitionTypeEnum[AcquisitionTypeEnum.PURCHASE];
    }

    public isSomeStep3NoOrderBtnInvalidate(): boolean {
        return this.dialogModel.isDeviceOrderRequested && !this.dialogModel.containsSomeRequestedDevicesContainers();
    }

    public isSomeStep4NoOrderBtnInvalid(): boolean {
        let result = this.dialogModel.isAccessoryOrderRequested && this.dialogModel.requestedAccessoryContainers.length === 0;
        result = result || (this.dialogModel.isWarrantyOrderRequested && this.dialogModel.requestedWarrantyContainers.length === 0);
        result = result || (this.dialogModel.isDeviceOrderRequested && this.dialogModel.isServiceOrderRequested && !this.dialogModel.isServiceDescriptionActive);
        result = result || (this.dialogModel.isUpgradesOrderRequested && this.dialogModel.requestedUpgradesContainers.length === 0);
        return result;
    }
}



